import { useParams } from 'react-router-dom';

import { GetFullClaimContextQueryReturnValues } from '@savgroup-front-common/core/api/Claim/getFullClaimContextQuery';
import { DocumentData } from '@savgroup-front-common/core/formatters/getDocumentNameTranslated';
import { useGetCarrierLabelsInfosQuery } from '@savgroup-front-common/core/hooks/useGetCarrierLabelsInfosQuery';
import { useListFileAttachmentsFromControlQuery } from '@savgroup-front-common/core/hooks/useListFileAttachmentsFromControlQuery';

import { adaptAdditionalInformationToDocumentData } from './adapters/adaptAdditionalInformationToDocumentData';
import { adaptClaimDocumentsToClientDocumentData } from './adapters/adaptClaimDocumentsToClientDocumentData';
import { adaptClaimDocumentsToVoucherDocumentData } from './adapters/adaptClaimDocumentsToVoucherDocumentData';
import { adaptControlAttachmentsToDocumentData } from './adapters/adaptControlAttachmentsToDocumentData';
import { adaptShippingLabelsToDocumentData } from './adapters/adaptShippingLabelsToDocumentData';

interface UseGetDocumentsArgs {
  fullClaim: GetFullClaimContextQueryReturnValues;
}
interface UseGetDocumentsReturnValue {
  allDocuments: DocumentData[];
}

const useGetDocuments = ({
  fullClaim,
}: UseGetDocumentsArgs): UseGetDocumentsReturnValue => {
  const { fileId } = useParams() as { fileId: string };

  const { carriersLabels: shippingLabels } =
    useGetCarrierLabelsInfosQuery({ fileId }) || [];

  const { fileAttachments } = useListFileAttachmentsFromControlQuery({
    fileId,
  });

  const allDocuments = [
    ...adaptClaimDocumentsToVoucherDocumentData({
      documents: fullClaim?.documents,
    }),
    ...adaptShippingLabelsToDocumentData({ shippingLabels }),
    ...adaptClaimDocumentsToClientDocumentData({
      documents: fullClaim?.documents,
    }),
    ...adaptAdditionalInformationToDocumentData({
      additionalInformation: fullClaim?.additionalInformation,
      fileId,
    }),
    ...adaptControlAttachmentsToDocumentData({ fileAttachments }),
  ];

  return { allDocuments };
};

export default useGetDocuments;
